import { FC } from 'react';
import { Button, ButtonPropsTypes, ButtonSize, IconButton, IconButtonProps } from '../../Form';
import { FAIcon, IconStyle } from '../../Icons';
import { CardPropsTypes } from './types/propsType';
import styles from './index.module.scss';
import { HeaderStyle, ButtonType, HeaderFlex } from './types/enums';

export const Card: FC<CardPropsTypes> = (props: CardPropsTypes) => {
  const {
    key = '',
    title = '',
    button = [],
    buttonType = ButtonType.TEXT,
    htmlTag: Tag = 'h2',
    headerStyle = HeaderStyle.HEADER_4,
    headerFlex = HeaderFlex.SPACE_BETWEEN,
    classes = '',
    children,
    containerWidth = '',
    containerHeight = '',
    buttonLabel,
    showBackButton = false,
    backButton,
  } = props;

  return (
    <section
      className={classes ? styles['card'] + ' ' + classes : styles['card']}
      data-testid="card-container"
      key={key}
      style={{ width: containerWidth ?? null, height: containerHeight ?? null }}
    >
      {(title || button.length > 0) && (
        <div className={styles[`card-header-flex-${headerFlex}`]}>
          {showBackButton ? (
            <div className={styles['card-header-icon']}>
              <FAIcon iconName="chevron-left" onClick={backButton} iconStyle={IconStyle.SOLID} />
            </div>
          ) : null}
          <Tag className={styles[`card-header-style-${headerStyle}`]}>{title}</Tag>
          <div className={styles['card-actions-container']}>
            {buttonLabel}
            {button.map((btn) => {
              if (btn.hidden) {
                return null;
              }

              if (buttonType === ButtonType.TEXT) {
                return <Button size={ButtonSize.SMALL} {...(btn as ButtonPropsTypes)} />;
              } else if (buttonType === ButtonType.ICON) {
                return <IconButton {...(btn as IconButtonProps)} />;
              } else {
                return <></>;
              }
            })}
          </div>
        </div>
      )}
      <div className={styles['card-body']}>{children}</div>
    </section>
  );
};

export default Card;
export { HeaderStyle, HeaderFlex, ButtonType };
export type { CardPropsTypes };
